import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  dialogMainContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    minHeight: '136px',
  },
  form: {
    width: '100%',
  },
}));
